(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  function findVolumeDiscountRoot(scope) {
    if (!scope) return null;
    var selectors = [
      '[class*="dealeasy"]',
      '[id*="dealeasy"]',
      '[class*="lb-volume-discount"]',
      '[class*="lb_volume_discount"]',
      '[id*="lb-volume"]',
      '[id*="volume-discount"]',
      '[data-lb-volume-discount]',
      '[data-dealeasy]',
      '.lb-volume-discount'
    ];
    var i;
    var el;
    for (i = 0; i < selectors.length; i++) {
      el = scope.querySelector(selectors[i]);
      if (el && !el.closest('[data-volume-discount-anchor]')) {
        return el;
      }
    }
    var tables = scope.querySelectorAll('table');
    for (i = 0; i < tables.length; i++) {
      var tbl = tables[i];
      if (tbl.closest('[data-volume-discount-anchor]')) {
        continue;
      }
      if (tbl.closest('.product-main__tiers')) {
        continue;
      }
      var body = (tbl.textContent || '').toLowerCase();
      if (
        body.indexOf('discounted') === -1 &&
        body.indexOf('discount') === -1 &&
        body.indexOf('dealeasy') === -1 &&
        body.indexOf('bulk') === -1
      ) {
        continue;
      }
      var wrap = tbl;
      var depth = 0;
      while (wrap && wrap !== scope && depth < 10) {
        var txt = wrap.textContent || '';
        if (txt.indexOf('Bulk discount') !== -1) {
          return wrap;
        }
        wrap = wrap.parentElement;
        depth++;
      }
      return tbl.parentElement || tbl;
    }
    return null;
  }

  function moveVolumeDiscountNearQty() {
    var root = document.querySelector('[data-product-root]');
    var anchor = document.querySelector('[data-volume-discount-anchor]');
    if (!root || !anchor) {
      return;
    }
    var widget = findVolumeDiscountRoot(root);
    if (!widget || anchor.contains(widget)) {
      return;
    }
    try {
      anchor.appendChild(widget);
      try {
        window.dispatchEvent(new CustomEvent('mogi:volume-discount-ready'));
      } catch (e2) {}
    } catch (e) {}
  }

  function initRelocate() {
    moveVolumeDiscountNearQty();
    var root = document.querySelector('[data-product-root]');
    if (!root) {
      return;
    }
    var scheduled = false;
    function schedule() {
      if (scheduled) {
        return;
      }
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        moveVolumeDiscountNearQty();
      });
    }
    var observer = new MutationObserver(function () {
      schedule();
    });
    observer.observe(root, { childList: true, subtree: true });
    [300, 1200, 3000].forEach(function (ms) {
      setTimeout(moveVolumeDiscountNearQty, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelocate);
  } else {
    initRelocate();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
